import { render, staticRenderFns } from "./AwardContainer.vue?vue&type=template&id=1272a83f&scoped=true"
import script from "./AwardContainer.vue?vue&type=script&lang=js"
export * from "./AwardContainer.vue?vue&type=script&lang=js"
import style0 from "./AwardContainer.vue?vue&type=style&index=0&id=1272a83f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272a83f",
  null
  
)

export default component.exports